const appName = ({
  isMobilePhone,
  isTablet,
}: {
  isMobilePhone?: boolean;
  isTablet?: boolean;
} = {}): string => {
  if (isMobilePhone) {
    return 'mobileweb';
  }
  if (isTablet) {
    return 'tabletweb';
  }
  return 'web';
};

export default appName;
